<div class="container-fluid">
  <div class="row">
    <app-display-counts-widget
      [widgetPanelCounts]="widgetPanelCounts"
      [title]="'Expiring Insurance'"
    ></app-display-counts-widget>
  </div>
</div>
